import type { Enums } from "../types";

/**
 * This function returns the color associated with a partner report state.
 * @param state
 * @returns
 */
export function getPartnerReportStateColor(state: Enums<"partnerReportState">) {
	switch (state) {
		case "pending":
			return "gray";
		case "approved":
			return "emerald";
	}
}
